import React from 'react'

import RouteLayout from '../../RouteLayout'
import { Buttons, Form, Table } from './Components'
import Spinner from '../../common/Spinner'
import { useSelector } from 'react-redux'


export default function StudentsInfo () {

  const { loader, form, data } = useSelector(state => state.reports.studentsInfo)

  const hasData = !!(data?.summary || data?.discharged)

  return (
    <RouteLayout title={'Сведения об обучающихся (форма №4/СВУ)'}>
      <Form form={form}/>
      <Buttons visible={hasData} data={data}/>
      {loader
        ? <Spinner />
        : <Table data={data}/>
      }
    </RouteLayout>
  )
}
